import * as React from "react";
const FormFieldSpinnerUp = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 5", fill: "currentColor", width: size || "8", height: size || "5", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 4 .8 4.8 4 1.5 7.3 4.8 8 4 4 0z" }));
FormFieldSpinnerUp.displayName = "FormFieldSpinnerUp";
var FormFieldSpinnerUp_default = FormFieldSpinnerUp;
export {
  FormFieldSpinnerUp_default as default
};
